import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./MakesSpecial.css";

//Import SVG Icons
import { TrustedNetwork , SupportIcon , QulaityControlIcon , BookingVerified} from '../components/SvgIcons';

const fallbackFeatures = [
    { icon: <TrustedNetwork  />,  line1: "Trusted", line2: "Network" },
    { icon: <SupportIcon />, line1: "24/7 " , line2: "Support" },
    { icon: <QulaityControlIcon />, line1: "Requirements",  line2: "Quality Control" },
    { icon: <BookingVerified /> , line1: "Bharat Booking", line2: "Verified" },
];

const iconByKey = {
  'trusted-network': <TrustedNetwork />,
  support: <SupportIcon />,
  quality: <QulaityControlIcon />,
  verified: <BookingVerified />,
};

const SpecialFeatures = ({ items = [] }) => {
  const features = items.length
    ? items.map((item, index) => ({
        icon: iconByKey[item.key] || fallbackFeatures[index % fallbackFeatures.length].icon,
        line1: item.line1,
        line2: item.line2,
      }))
    : fallbackFeatures;

  return (
    <Container className="mt-50">
      <Row className="justify-content-center g-3">
        {features.map((feature, index) => (
          <Col key={index} xl={3} md={6} sm={12} xs={12}>
            <div className="feature-card d-flex align-items-center shadow-sm">
              <div className="feature-icon d-flex align-items-center justify-content-center">
              {feature.icon}
              </div>
              <div className="feature-text">
              <p className="mb-0 fw-semibold">
                {feature.line1}
                <br />
                {feature.line2}
            </p>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default SpecialFeatures;
